import React from 'react';
import merge from 'classnames';

import { SimpleIconProps } from '../types';

export const IconArrowRightV2 = ({ className }: SimpleIconProps) => (
  <svg
    className={merge(className)}
    fill="none"
    height="12"
    role="img"
    viewBox="0 0 14 12"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M0.672488 6.21975C0.672488 6.02084 0.751505 5.83008 0.892157 5.68942C1.03281 5.54877 1.22358 5.46976 1.42249 5.46976L10.112 5.46976L6.89149 2.25076C6.82176 2.18102 6.76644 2.09824 6.7287 2.00713C6.69096 1.91602 6.67154 1.81837 6.67154 1.71976C6.67154 1.62114 6.69096 1.52349 6.7287 1.43238C6.76644 1.34127 6.82176 1.25849 6.89149 1.18876C6.96122 1.11902 7.044 1.06371 7.13511 1.02597C7.22622 0.988232 7.32387 0.968809 7.42249 0.968809C7.5211 0.968809 7.61875 0.988232 7.70986 1.02597C7.80097 1.06371 7.88376 1.11902 7.95349 1.18876L12.4535 5.68876C12.5233 5.75842 12.5787 5.84119 12.6166 5.93231C12.6544 6.02342 12.6738 6.1211 12.6738 6.21976C12.6738 6.31841 12.6544 6.41609 12.6166 6.50721C12.5787 6.59832 12.5233 6.68109 12.4535 6.75076L7.95349 11.2508C7.81266 11.3916 7.62165 11.4707 7.42249 11.4707C7.22332 11.4707 7.03232 11.3916 6.89149 11.2508C6.75066 11.1099 6.67154 10.9189 6.67154 10.7198C6.67154 10.5206 6.75066 10.3296 6.89149 10.1888L10.112 6.96976L1.42249 6.96975C1.22358 6.96975 1.03281 6.89074 0.892157 6.75008C0.751505 6.60943 0.672488 6.41867 0.672488 6.21975Z"
      fill="white"
      fillRule="evenodd"
      stroke="white"
    />
  </svg>
);
